export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/bg-d7b2afd2967f32923824178224fb15d5.png";